import { render, staticRenderFns } from "./AndiamoErogazioneFormComponent.vue?vue&type=template&id=08ffceef&scoped=true"
import script from "./AndiamoErogazioneFormComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoErogazioneFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ffceef",
  null
  
)

export default component.exports